import HttpClient from './HttpClient';
import Account from './resources/Account';
import App from './resources/App';
import Job from './resources/Job';
import User from './resources/User';
import Sso from './resources/Sso';

export type RefreshToken = string;
export type AccessToken = string;

export default class BioLib {
    public readonly httpClient: HttpClient;
    public readonly account: Account;
    public readonly app: App;
    public readonly job: Job;
    public readonly sso: Sso;
    public readonly user: User;

    constructor(baseURL: string, refreshToken?: string) {
        this.httpClient = new HttpClient({ baseURL, refreshToken });

        this.account = new Account(this.httpClient);
        this.app = new App(this.httpClient);
        this.job = new Job(this.httpClient);
        this.sso = new Sso(this.httpClient);
        this.user = new User(this.httpClient);
    }
}
